import React, { useState, useEffect } from "react";
import Register from "./Register";
import Login from "./Login";
import api from "../utils/api"; // Adjust this to the correct import for your API utility

const TopHeader = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);

  useEffect(() => {
    const checkUserLoggedIn = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setIsLoggedIn(false);
          return;
        }

        const response = await api.get("/users/me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          setIsLoggedIn(true);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };

    checkUserLoggedIn();
  }, []);

  if (isLoggedIn === null) {
    return null;
  }
  return (
    <>
      {!isLoggedIn && (
        <div className="bg-temp w-full text-black py-2 px-4 flex flex-col sm:flex-row justify-center items-center ">
          <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
            <button
              onClick={() => setShowRegisterPopup(true)}
              className="bg-black text-white px-4 py-2 text-sm rounded-2xl font-medium hover:bg-gray-800 transition duration-200 text-center sm:text-left"
            >
              Sign Up & Get <span className="font-bold">$5 </span> Today
            </button>
          </div>
        </div>
      )}

      {/* Login Popup */}
      {showLoginPopup && (
        <Login
          onClose={() => setShowLoginPopup(false)}
          showRegister={() => {
            setShowLoginPopup(false);
            setShowRegisterPopup(true);
          }}
        />
      )}

      {/* Register Popup */}
      {showRegisterPopup && (
        <Register
          onClose={() => setShowRegisterPopup(false)}
          showLogin={() => {
            setShowRegisterPopup(false);
            setShowLoginPopup(true);
          }}
        />
      )}

      {/* Mobile version */}
      {!isLoggedIn && (
        <div className="flex items-center hidden justify-center space-x-4 w-full px-4 py-3 bg-temp lg:hidden font-inter">
          <button
            onClick={() => setShowRegisterPopup(true)}
            className="w-1/2 text-center justify-center inline-flex px-3 py-1.5 text-xs text-temp bg-black  font-medium hover:bg-black/90"
          >
            Sign Up & Get <span className="font-bold ml-1">$10</span> Today
          </button>
        </div>
      )}
    </>
  );
};

export default TopHeader;